
import React from 'react';

import ImageCardsBoxSale from '../../FormFields/ImageCardsBoxSale';
import Carousal from '../../FormFields/NewCarousal/Carousal';


const MessageA48 = (props) => {


    // return  <ImageCardsBoxSale {...props} />
    return <Carousal  {...props}/> 
}

export default MessageA48;